import Cookies from 'js-cookie';
import mixpanel from 'mixpanel-browser';
import { useEffect, useLayoutEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { NotFoundPage } from '@/pages/NotFoundPage';

import LazyHomePage from '@/pages/Home';
import LazyNoAccessPage from '@/pages/NoAccess';
import LazyTermsPage from '@/pages/Terms';
import LazyPrivacyPolicyPage from '@/pages/PrivacyPolicy';
import LazyOnPremisesTermsPage from '@/pages/OnPremises/Terms';
import LazyMaintenanceSupportServiceSpecificationPage from '@/pages/OnPremises/MaintenanceSupportServiceSpecification';
import LazySpecificBasedPage from '@/pages/SpecificBased';
import LazySolutionPage from '@/pages/Solution';
import LazyRegisterPage from '@/pages/Register';
import LazyContactPage from '@/pages/Contact';
import LazyShowcasePage from '@/pages/Showcase';
import LazyNewomanTakanawaPage from '@/pages/Showcase/NewomanTakanawa';
import LazySapporoFactoryPage from '@/pages/Showcase/SapporoFactory';
import LazyConciergePage from '@/pages/Concierge';
import LazyPricingPage from '@/pages/Pricing';
import { COOKIE_KEY_MIXPANEL } from '@mygpt/app';

/**
 * 路由切换时的滚动行为:
 * - 带 hash 时(如 /solution#feature-realtime):滚动到目标元素(扣除 header 高度)
 * - 无 hash 时:滚动到页面顶部
 *
 * 跨页 hash 跳转时,目标页面可能尚未渲染完,所以用轮询(最多 500ms)等元素出现。
 * 同页 hash 点击由 Navigation 组件自己拦截处理,不会走到这里。
 */
const HEADER_OFFSET = 80;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let attempt = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
          window.scrollTo({ top, behavior: 'smooth' });
          return;
        }
        if (attempt < 10) {
          attempt += 1;
          setTimeout(tryScroll, 50);
        }
      };
      tryScroll();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

export const AppRoutes = () => {
  // reset mixpanel distinct_id value
  useLayoutEffect(() => {
    const mixpanelCookieValue = Cookies.get(COOKIE_KEY_MIXPANEL);
    if (!mixpanelCookieValue) return;
    const newVal = JSON.parse(mixpanelCookieValue);
    newVal.distinct_id = 'gptbase';
    Cookies.set(COOKIE_KEY_MIXPANEL, JSON.stringify(newVal));
    mixpanel.track('visit', {
      url: window.location.href,
    });
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="/*" element={<LazyHomePage />} />
        <Route path="/solution" element={<LazySolutionPage />} />
        <Route path="/register" element={<LazyRegisterPage />} />
        <Route path="/contact" element={<LazyContactPage />} />
        <Route path="/privacy-policy" element={<LazyPrivacyPolicyPage />} />
        <Route path="/privacy" element={<LazyPrivacyPolicyPage />} />
        <Route path="/terms-of-use" element={<LazyTermsPage />} />
        <Route path="/terms" element={<LazyTermsPage />} />
        <Route path="/no-access" element={<LazyNoAccessPage />} />
        <Route path="/on-premises/terms-of-use" element={<LazyOnPremisesTermsPage />} />
        <Route
          path="/on-premises/maintenance-support-service-specification"
          element={<LazyMaintenanceSupportServiceSpecificationPage />}
        />
        <Route path="/legal/specific-based" element={<LazySpecificBasedPage />} />
        <Route path="/showcase" element={<LazyShowcasePage />} />
        <Route path="/showcase/newoman-takanawa" element={<LazyNewomanTakanawaPage />} />
        <Route path="/showcase/sapporo-factory" element={<LazySapporoFactoryPage />} />
        <Route path="/concierge" element={<LazyConciergePage />} />
        <Route path="/pricing" element={<LazyPricingPage />} />
      </Routes>
    </>
  );
};
